import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_SUBSCRIPTIONS_FOR = defineFcm('enable_subscriptions_for')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: ['corgi-front-end', 'monorail'],
		context: 'Page header and Membership features',
		description: 'Indicates if membership is enabled for a specific country',
		import: false,
	});
